<template>
  <base-section id="theme-features">
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <base-avatar-card
            v-for="(feature, i) in features"
            :key="i"
            v-bind="feature"
            align="left"
            horizontal
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-img src="@/assets/Baby.jpg" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionThemeFeatures",

  data: () => ({
    features: [
      {
        color: "orange",
        dark: true,
        title: "Domestic Helper",
        icon: "mdi-heart",
        text:
          "An assistant to your household and family, serving your company with care and joy. "
      },
      {
        color: "orange",
        dark: true,
        title: "Confinement Nanny",
        icon: "mdi-heart",
        text:
          "Caregiver for the newborn baby and the mommies during the minimum 1 month confinement period."
      },

      {
        color: "orange",
        dark: true,
        title: "Local Helper & Caregiver",
        icon: "mdi-heart",
        text:
          "Adhoc or long terms assistant to your household and family member."
      }
    ]
  })
};
</script>
